var cilBed = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M416,224H208V344.619H185.846v-41A87.716,87.716,0,0,0,98.229,216H48V152H16V496H48V448.257l416,3.328V496h32V304A80.091,80.091,0,0,0,416,224ZM48,248H98.229a55.68,55.68,0,0,1,55.617,55.617v41H48ZM464,419.584,48,416.256V376.619H464Zm0-74.965H240V256H416a48.055,48.055,0,0,1,48,48Z' class='ci-primary'/>"];

export { cilBed };
//# sourceMappingURL=cil-bed.js.map
